import { render, staticRenderFns } from "./registrations.vue?vue&type=template&id=d1d4bd24"
import script from "./registrations.vue?vue&type=script&lang=js"
export * from "./registrations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports